import { render, staticRenderFns } from "./user-email-settings.vue?vue&type=template&id=7fe3d0af&scoped=true"
import script from "./user-email-settings.vue?vue&type=script&lang=js"
export * from "./user-email-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe3d0af",
  null
  
)

export default component.exports